import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.svg";
import { Formik } from "formik";
import * as Yup from "yup";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`;
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`;
const Textarea = styled(Input).attrs({ as: "textarea" })`
  ${tw`h-24`}
`;
const Error = tw.p`text-red-600`;
const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8 `;
const disabledStyles = tw`opacity-75 cursor-not-allowed`;

export default ({
  subheading = "Contact Us",
  heading = (
    <>
      Feel free to <span tw="text-primary-500">get in touch</span>
      <wbr /> with us.
    </>
  ),
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  submitButtonText = "Send",
  formAction = "#",
  formMethod = "get",
  textOnLeft = true,
}) => {
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Enter valid Email").required("Email Required"),
    name: Yup.string().required("Name Required"),
    // subject: Yup.string().required("Subject Required "),
    message: Yup.string().required("Enter Message"),
  });

  const submitHandler = (value) => {
    console.log(value);
  };
  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
            {/* <Form action={formAction} method={formMethod}>
              <Input type="email" name="email" placeholder="Your Email Address" />
              <Input type="text" name="name" placeholder="Full Name" />
              <Input type="text" name="subject" placeholder="Subject" />
              <Textarea name="message" placeholder="Your Message Here" />
              <SubmitButton type="submit">{submitButtonText}</SubmitButton>
            </Form> */}
            <Formik
              initialValues={{
                email: "",
                name: "",
                subject: "",
                message: "",
              }}
              validationSchema={validationSchema}
              onSubmit={submitHandler}
            >
              {({
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                touched,
                values,
                dirty,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Input
                    type="email"
                    name="email"
                    placeholder="Your Email Address *"
                    value={values?.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors?.email && touched?.email && (
                    <Error>{errors?.email}</Error>
                  )}
                  <Input
                    type="text"
                    name="name"
                    placeholder="Full Name *"
                    value={values?.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors?.name && touched?.name && (
                    <Error>{errors?.name}</Error>
                  )}
                  {/* <Input
                    type="text"
                    name="subject"
                    placeholder="Subject *"
                    value={values?.subject}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors?.subject && touched?.subject && (
                    <Error>{errors?.subject}</Error>
                  )} */}
                  <Textarea
                    name="message"
                    placeholder="Your Message Here *"
                    value={values?.message}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors?.message && touched?.message && (
                    <Error>{errors?.message}</Error>
                  )}
                  <SubmitButton
                    type="submit"
                    disabled={isSubmitting && dirty}
                    css={isSubmitting ? disabledStyles : null}
                  >
                    {submitButtonText}
                  </SubmitButton>
                </Form>
              )}
            </Formik>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
